import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

var instance = null as ApplicationInsights | null;

function initialize() {
    const appInsightsConnectionString = process.env.REACT_APP_INSIGHTS_CONN_STRING;
    if (!!appInsightsConnectionString) {
        const browserHistory = createBrowserHistory({});
        var reactPlugin = new ReactPlugin();
        // *** Add the Click Analytics plug-in. ***
        var clickPluginInstance = new ClickAnalyticsPlugin();
        var clickPluginConfig = {
            autoCapture: true
        };
        instance = new ApplicationInsights({
            config: {
                connectionString: appInsightsConnectionString,
                extensions: [reactPlugin, clickPluginInstance],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: browserHistory },
                    [clickPluginInstance.identifier]: clickPluginConfig
                }
            }
        });
        instance.loadAppInsights();
    }
}

export const applicationInsights = {
    initialize,
    getInstance: () => {
        if (!instance) {
            initialize();
        }
        return instance;
    }
};